<template>

<div id="galleries-container">

  <!-- Random featured galleries -->
  <div id="featured-galleries-container">
    <div id="featured-galleries">
      <div id="gallery-labels">
        <p>Visit MWNF Galleries</p>
        <a :href="urls.galleries + '/list'"><p>See more <span v-if="!lessThan399">Galleries </span>>></p></a>
      </div>
      <!-- Show loader while gallery info is being fetched -->
      <LoaderComponent v-if="!loaded" />
      <div v-else id="gallery-links">
        <div class="gallery-item" 
          v-for="(gallery, index) in galleries" :key="gallery.galleryName" :class="`gallery-${index + 1}`">
          <a :href="gallery.links[2].href">
            <img class="gallery-image" :src="gallery.image" />
            <p class="gallery-name">{{ gallery.galleryName.toUpperCase() }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- MWNF Museums -->
  <div id="mwnf-museums-container">
    <div id="mwnf-museums">
      <div id="museums-label">
        <p>Other Virtual Museums</p>
      </div>
      <div id="museum-links">
        <div id="museum-item-1" class="museum-item">
          <a :href="urls.islamicArt">
            <img class="museum-image" src="../assets/dia.jpg"/>
            <p id="museum-name-dia" class="museum-name">Discover Islamic Art</p>
          </a>
        </div>
        <div id="museum-item-2" class="museum-item">
          <a :href="urls.baroqueArt">
            <img class="museum-image" src="../assets/dba.jpg"/>
            <p id="museum-name-dba" class="museum-name">Discover Baroque Art</p>
          </a>
        </div>
        <div id="museum-item-3" class="museum-item">
          <a :href="urls.sharingHistory">
            <img class="museum-image" src="../assets/sh.jpg"/>
            <p id="museum-name-sh" class="museum-name">Sharing History</p>
          </a>
        </div>
      </div>
    </div>
  </div>

</div>

</template>



<script>

import LoaderComponent from "./LoaderComponent.vue";
import media from "../mixins/media.js";
export default {
  name: "FeaturedGalleries",
  components: {
    "LoaderComponent": LoaderComponent
  },
  mixins: [media],
  data() {
    return {
      lessThan399: window.matchMedia("(max-width: 399px)").matches,
      loaded: false,
      galleries: {},
      urls: {
        portal: process.env.VUE_APP_URL_PORTAL,
        baroqueArt: process.env.VUE_APP_URL_DBA,
        islamicArt: process.env.VUE_APP_URL_DIA,
        sharingHistory: process.env.VUE_APP_URL_SH,
        galleries: process.env.VUE_APP_URL_SELF,
        images: process.env.VUE_APP_URL_IMAGES,
      },
    }
  },
  methods: {
    loadGalleries: function () {
      axios({ method: "GET", "url": `${process.env.VUE_APP_DXA_ENDPOINT}/thg/galleries/featured?hash=${process.env.VUE_APP_API_HASH}` }).then(result => {
        this.galleries = result.data.items;
        this.loaded = true;
      }, error => {
        console.error(error);
      });
    }
  },
  mounted() {
    this.loadGalleries();
  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#galleries-container {
  display: grid;
  grid-template-columns: 75% 25%;
  /* IE */
  display: -ms-grid;
  -ms-grid-columns: 75% 25%;
  height: 100%;
  width: 100%;
  background-color: white;
}

/* IE */
#featured-galleries-container {
  -ms-grid-column: 1;
  height: 100%;
  max-height: 300px;
}
#mwnf-museums-container {
  -ms-grid-column: 2;
  height: 100%;
  max-height: 300px;
}

#featured-galleries {
  @include flex-center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 20px 30px;
}
  #gallery-labels {
    @include flex-center;
    width: 100%;
    justify-content: space-between;
    font-size: 115%;
    margin-bottom: 12px;
    color: $theme-medium-dark;
  }
    #gallery-labels p {
      padding: 2px 0;
      border-bottom: 1px solid $theme-medium-dark;
    }
    #gallery-labels a {
      text-decoration: none;
      color: $theme-medium-dark;
    }
  .loader-container {
    min-height: 200px;
  }
  #gallery-links {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 24px;
    /* IE */
    display: -ms-grid;
    -ms-grid-columns: 1fr 24px 1fr 24px 1fr 24px 1fr;
  }
    /* IE */
    .gallery-1 {
      -ms-grid-column: 1;
    }
    .gallery-2 {
      -ms-grid-column: 3;
    }
    .gallery-3 {
      -ms-grid-column: 5;
    }
    .gallery-4 {
      -ms-grid-column: 7;
    }
    .gallery-item {
      @include flex-center;
      position: relative;
    }
      .gallery-image {
        @include image-scale;
      }
      .gallery-name {
        @include flex-center;
        height: 3em;
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        color: $light-text;
        background-color: rgba(black, 0.6);
        text-align: center;
      }

#mwnf-museums {
  @include flex-center;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 20px 30px;
}
  #museums-label {
    @include flex-center;
    justify-content: flex-start;
    width: 100%;
    font-size: 115%;
    margin-bottom: 12px;
    color: $theme-medium-dark;
  }
    #museums-label p {
      padding: 2px 0;
      border-bottom: 1px solid $theme-medium-dark;
    }
  #museum-links {
    @include flex-center;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
  }
    .museum-item {
      @include flex-center;
      position: relative;
      height: 100%;
      width: 100%;
    }
      .museum-image {
        @include image-scale;
      }
      .museum-name {
        @include flex-center;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 150%;
        font-weight: bold;
        text-shadow: 0 0 10px white;
      }
        // Black text shadow to make yellow text readable
        #museum-name-dia {
          color: $dia-yellow;
          text-shadow: 0 0 10px black;
        }
        #museum-name-dba {
          color: $dba-blue;
        }
        #museum-name-sh {
          color: $sh-red;
        }

@media only screen and (max-width: 1199px) {
  #gallery-labels,
  #museums-label {
    font-size: 100%;
  }
  .museum-name {
    font-size: 125%;
  }
}

@media only screen and (max-width: 974px) {
  #galleries-container {
    display: flex;
    flex-direction: column;
  }
    .gallery-name {
      font-size: 95%;
    }
  #mwnf-museums {
    padding-top: 0;
    padding-bottom: 40px;
  }
    #museum-links {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 24px;
      /* IE */
      display: -ms-grid;
      -ms-grid-columns: 1fr 24px 1fr 24px 1fr;
      height: 100%;
      width: 100%;
    }
      #museum-item-1 {
        -ms-grid-column: 1;
      }
      #museum-item-2 {
        -ms-grid-column: 3;
      }
      #museum-item-3 {
        -ms-grid-column: 5;
      }
      .museum-name {
        font-size: 140%;
      }
}

@media only screen and (max-width: 849px) {
  .museum-name {
    font-size: 130%;
  }
}

@media only screen and (max-width: 724px) {
  #featured-galleries-container,
  #mwnf-museums-container {
    max-height: none;
  }
  .loader-container {
    min-height: 450px;
  }
  #gallery-links {
    justify-content: center;
    grid-template-columns: repeat(2, 200px);
    column-gap: 18px;
    row-gap: 18px;
    /* IE */
    display: -ms-grid;
    -ms-grid-columns: 1fr 200px 18px 200px 1fr;
    -ms-grid-rows: 200px 18px 200px;
    height: 100%;
    width: 100%;
  }
    .gallery-1 {
      -ms-grid-column: 2;
      -ms-grid-row: 1;
    }
    .gallery-2 { 
      -ms-grid-column: 4;
      -ms-grid-row: 1;
    }
    .gallery-3 {
      -ms-grid-column: 2;
      -ms-grid-row: 3;
    }
    .gallery-4 {
      -ms-grid-column: 4;
      -ms-grid-row: 3;
    }
  #museum-links {
    @include flex-center;
    justify-content: space-between;
    height: 225px;
  }
}

@media only screen and (max-width: 599px) {
  #gallery-links {
    grid-template-columns: repeat(2, 1fr);
    /* IE */
    -ms-grid-columns: 1fr 18px 1fr;
    -ms-grid-rows: 1fr 18px 1fr;
  }
    .gallery-1 {
      -ms-grid-column: 1;
      -ms-grid-row: 1;
    }
    .gallery-2 { 
      -ms-grid-column: 3;
      -ms-grid-row: 1;
    }
    .gallery-3 {
      -ms-grid-column: 1;
      -ms-grid-row: 3;
    }
    .gallery-4 {
      -ms-grid-column: 3;
      -ms-grid-row: 3;
    }
}

@media only screen and (max-width: 499px) {
  .loader-container {
    min-height: 400px;
  }
  #gallery-links {
    column-gap: 15px;
    row-gap: 15px;
  }
}

@media only screen and (max-width: 399px) {
  .loader-container {
    min-height: 300px;
  }
  #gallery-links {
    column-gap: 8px;
    row-gap: 8px;
  }
  #museum-links {
    height: auto;
  }
    .museum-item {
      margin-bottom: 10px;
    }
}

</style>
